import { permissionAreaKeyNameOf } from "../../../helpers/permission.helpers";
import { ProductArea } from "../../../models/roles";
import { MenuMainNode } from "./nodes";

export function entityKeyResolver<T extends ProductArea>(name: Extract<keyof T, string>): string { return name; };

export const productMenu: MenuMainNode = {
    icon: 'catalogIconTemplate',
    title: 'Menu.ProductCatalog.Name',    
    rootPath: '/products',
    areaPermissionKey: permissionAreaKeyNameOf('product'),
    children: [
        {
            title: 'Menu.ProductCatalog.Manufacturers.Name',
            abbreviation: 'Menu.ProductCatalog.Manufacturers.Abbreviation',
            link: '/products/manufacturers',
            entityPermissionKey: entityKeyResolver('manufacturers')
        },
        {
            title: 'Menu.ProductCatalog.Vendors.Name',
            abbreviation: 'Menu.ProductCatalog.Vendors.Abbreviation',
            link: '/products/vendors',
            entityPermissionKey: entityKeyResolver('vendors')
        },
        {
            title: 'Menu.ProductCatalog.ProductGroups.Name',
            abbreviation: 'Menu.ProductCatalog.ProductGroups.Abbreviation',
            link: '/products/product-groups',
            entityPermissionKey: entityKeyResolver('productGroups')
        },
        {
            title: 'Menu.ProductCatalog.ProductCategories.Name',
            abbreviation: 'Menu.ProductCatalog.ProductCategories.Abbreviation',
            link: '/products/product-categories',
            entityPermissionKey: entityKeyResolver('productCategories')
        },
        {
            title: 'Menu.ProductCatalog.Products.Name',
            abbreviation: 'Menu.ProductCatalog.Products.Abbreviation',
            link: '/products/products',
            entityPermissionKey: entityKeyResolver('products')
        },
        {
          title: 'Menu.ProductCatalog.ItemMaster.Name',
          abbreviation: 'Menu.ProductCatalog.ItemMasters.Abbreviation',
          link: '/products/item-master',
          entityPermissionKey: entityKeyResolver('itemMaster')
        },
        {
            title: 'Menu.ProductCatalog.PriceLists.Name',
            abbreviation: 'Menu.ProductCatalog.PriceLists.Abbreviation',
            link: '/products/price-lists',
            entityPermissionKey: entityKeyResolver('priceLists')
        },
    ]
};
